document.addEventListener("click", function (event) {
  const button = event.target.closest(".product-card__swatch-button[data-variant-image]");

  if (!button) return;

  const card = button.closest(".product-card");

  if (!card) return;

  const imageUrl = button.getAttribute("data-variant-image");
  const imageSrcset = button.getAttribute("data-variant-image-srcset");
  const imageAlt = button.getAttribute("data-variant-image-alt") || "";

  if (!imageUrl) return;

  let image =
    card.querySelector(".product-card__image-wrapper.is-active .product-card__image:not(.product-card__image--hover)") ||
    card.querySelector(".product-card__image:not(.product-card__image--hover)");

  if (!image) return;

  image.src = imageUrl;
  image.setAttribute("src", imageUrl);
  image.setAttribute("data-src", imageUrl);

  if (imageSrcset) {
    image.srcset = imageSrcset;
    image.setAttribute("srcset", imageSrcset);
    image.setAttribute("data-srcset", imageSrcset);

    const picture = image.closest("picture");

    if (picture) {
      picture.querySelectorAll("source").forEach(function (source) {
        source.srcset = imageSrcset;
        source.setAttribute("srcset", imageSrcset);
        source.setAttribute("data-srcset", imageSrcset);
      });
    }
  }

  image.alt = imageAlt;

  card.querySelectorAll(".product-card__swatch-button").forEach(function (swatch) {
    swatch.classList.remove("is-active");
  });

  button.classList.add("is-active");
});